import React, { useContext, useState } from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';
import { QuoteContext } from '.';
import MILAN_LOGO_WHITE_WIDE from '../assets/Milan_Logo_White_Wide.svg';
import { hasTerm } from '../utils/lenderUtils.ts';

export function QuoteController() {
  const { active, setActive, handleClearOptions } = useContext(QuoteContext);
  const [showToast, setShowToast] = useState(false);

  const has24 = hasTerm(active.lender, 24);
  const has36 = hasTerm(active.lender, 36);
  const has60 = hasTerm(active.lender, 60);

  const handleDisabledClick = () => {
    setShowToast(true);
  };

  return (
    <header
      className={`${
        active.preSale ? 'milan-bg-primary' : 'milan-bg-tur'
      } py-4 padding-x`}
    >
      <nav className='container-fluid h-100 px-0'>
        <div className='row h-100 gy-4 justify-content-md-between align-items-center'>
          <div className='col-12 col-md-auto text-center'>
            <img
              className='logo'
              src={MILAN_LOGO_WHITE_WIDE}
              alt='Milan Laser Logo'
            />
          </div>
          <div className='col-12 col-md-auto'>
            <ul className='row gx-2 gx-sm-3 gy-3 justify-content-center justify-content-md-end mb-0'>
              <li className='col-auto'>
                <span
                  onClick={!has24 ? handleDisabledClick : undefined}
                  style={{ cursor: !has24 ? 'not-allowed' : 'default' }}
                >
                  <button
                    type='button'
                    disabled={!has24}
                    onClick={() =>
                      setActive((prev) => ({ ...prev, financePlan: 24 }))
                    }
                    className={`toggle-btns rounded-start ${
                      active.financePlan === 24 ? 'active' : ''
                    }`}
                    style={{ pointerEvents: !has24 ? 'none' : 'auto' }}
                  >
                    24 Month
                  </button>
                </span>
                <span
                  onClick={!has36 ? handleDisabledClick : undefined}
                  style={{ cursor: !has36 ? 'not-allowed' : 'default' }}
                >
                  <button
                    type='button'
                    disabled={!has36}
                    onClick={() =>
                      setActive((prev) => ({ ...prev, financePlan: 36 }))
                    }
                    className={`toggle-btns ${
                      active.financePlan === 36 ? 'active' : ''
                    }`}
                    style={{ pointerEvents: !has36 ? 'none' : 'auto' }}
                  >
                    36 Month
                  </button>
                </span>
                <span
                  onClick={!has60 ? handleDisabledClick : undefined}
                  style={{ cursor: !has60 ? 'not-allowed' : 'default' }}
                >
                  <button
                    type='button'
                    disabled={!has60}
                    onClick={() =>
                      setActive((prev) => ({ ...prev, financePlan: 60 }))
                    }
                    className={`toggle-btns rounded-end ${
                      active.financePlan === 60 ? 'active' : ''
                    }`}
                    style={{ pointerEvents: !has60 ? 'none' : 'auto' }}
                  >
                    60 Month
                  </button>
                </span>
              </li>
              <li className='col-auto'>
                <button
                  type='button'
                  onClick={handleClearOptions}
                  className='rounded px-2 milan-text-navy milan-bg-white'
                >
                  <span className='d-md-none'>Reset</span>{' '}
                  <span className='d-none d-md-inline'>Clear Options</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <ToastContainer
        position='bottom-center'
        className='p-3'
        //   style={{ position: 'fixed', zIndex: 9999 }}
      >
        <Toast
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={3000}
          autohide
          bg='info'
        >
          <Toast.Header>
            <strong className='me-auto'>
              Term Not Available For Selected Lender
            </strong>
          </Toast.Header>
          <Toast.Body className='milan-bg-tur text-white'>
            Please select another lender.
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </header>
  );
}

export default QuoteController;
